import React from 'react';

import { Box } from '@mui/joy';

import { LiveLineData, MarkerData, MapType } from '../Mapbox/mapTypes';
import MapDroneView from '../MapDroneView';
import SimpleVideoStream from '../SimpleVideoStream';
import { FitMode } from '../VideoScaler';

interface MainViewSwitcherProps {
  isFullscreenVideo: boolean;
  liveLine: LiveLineData;
  markerImages: { [id: string]: MarkerData };
  mapRef: React.MutableRefObject<MapType | null>;
  videoUrl: string;
  initialZoom?: number;
  fitMode?: FitMode;
  onFitModeChange?: (mode: FitMode) => void;
}

const MainViewSwitcher: React.FC<MainViewSwitcherProps> = React.memo(
  ({ isFullscreenVideo, liveLine, markerImages, mapRef, videoUrl, initialZoom, fitMode, onFitModeChange }) => {
    return (
      <>
        <Box
          className='w-full h-full flex items-center justify-center'
          sx={{
            bgcolor: 'background.level1',
            opacity: isFullscreenVideo ? 1 : 0,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: isFullscreenVideo ? 10 : 1,
            pointerEvents: isFullscreenVideo ? 'auto' : 'none'
          }}
        >
          <MapDroneView
            liveLine={liveLine}
            markers={markerImages}
            mapRef={mapRef}
            customZoomControls
            initialZoom={initialZoom}
          />
        </Box>

        <Box
          className='w-full h-full flex items-center justify-center'
          sx={{
            bgcolor: 'background.level1',
            opacity: !isFullscreenVideo ? 1 : 0,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: !isFullscreenVideo ? 10 : 1,
            pointerEvents: !isFullscreenVideo ? 'auto' : 'none'
          }}
        >
          <SimpleVideoStream key={videoUrl} url={videoUrl} fitMode={fitMode} onFitModeChange={onFitModeChange} />
        </Box>
      </>
    );
  }
);

MainViewSwitcher.displayName = 'MainViewSwitcher';

export default MainViewSwitcher;
